import { Dispatch, createContext, useContext } from "react";
import { Action } from "../../../types/reducer-action";
import { IMemo, ISearchUsersResult, IUserProfile } from "../../../types/user";
import { DataEntryState, dataEntryReducer } from "../../common/data-entry-reducer";

export enum UserManagerDomain {
  Memos = 'memos'
}

export interface UserProfileForm extends IUserProfile {
  individualName?: string;
}

export interface UserProfileState extends DataEntryState<ISearchUsersResult, UserProfileForm> {
  subdomains: {
    [UserManagerDomain.Memos]?: DataEntryState<IMemo, IMemo>;
  }
}

export const userProfileReducer = (state: UserProfileState, action: Action): UserProfileState =>
  dataEntryReducer<ISearchUsersResult, UserProfileForm>(state, action);

export const UserContext = createContext<UserProfileState>({} as UserProfileState);
export const useUserState = () => useContext(UserContext);

export const UserDispatchContext = createContext<Dispatch<Action>>(() => { });
export const useUserDispatch = () => useContext(UserDispatchContext);
